export default "__VITE_ASSET__D1hr3Evh__"